<template>
	<v-container fluid>
		<v-row>
			<v-col cols="9">
				<v-autocomplete auto-select-first chips deletable-chips solo dense multiple v-model="values" :items="items"></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-btn :disabled="!values?.length" color="success" @click="addWorkflows">Add modules to process</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { allProcessNodes } from '@/store/modules/processes/getters';
import { id as selectedProcessId, process as selectedProcess, availableWorkflows } from '@/store/modules/selectedProcess/getters';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { getFlowsForSelectedProject } from '@/store/modules/selectedProject/actions';
import { loadAvailableWorkflows } from '@/store/modules/selectedProcess/actions';
import { createNode } from '@/store/modules/processes/actions';

export default {
	name: 'ProcessNewNodeForm',
	computed: {
		...mapGettersShorthand({ getWorkflow, selectedProcessId, selectedProcess, allProcessNodes, availableWorkflows }),
		items: (t) =>
			t.availableWorkflows
				.map(t.getWorkflow)
				.filter(Boolean)
				.reverse()
				.map(({ id: value, workflow_title: text }) => ({ text, value })),
	},
	methods: {
		...mapActionsShorthand({ getFlowsForSelectedProject, createNode, loadAvailableWorkflows }),
		async addWorkflows() {
			await Promise.all(this.values.map((workflow) => this.createNode({ workflow, processId: this.selectedProcessId })));
			this.values = [];
			await this.loadAvailableWorkflows();
		},
	},
	async mounted() {
		await this.getFlowsForSelectedProject();
		await this.loadAvailableWorkflows();
	},
	data: () => ({
		values: [],
	}),
};
</script>
<style scoped></style>
